import { render, staticRenderFns } from "./noIndex.vue?vue&type=template&id=499d03e8&"
import script from "./noIndex.vue?vue&type=script&lang=ts&"
export * from "./noIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports